// extracted by mini-css-extract-plugin
module.exports = {"ServicesDiv":"Portfolio_ServicesDiv__1pX37","nameH1":"Portfolio_nameH1__2t4sc","bodyDiv":"Portfolio_bodyDiv__t5iux"};